/**
 * Adzuki.Debounce
 */

(function Debounce($, Adzuki)
{
	"use strict";

	// cribbed from _.js, because it's great
	var debounce = function _debounce(func, wait, immediate) {
		var timeout;
		return function _debounced() {
			var self = this, args = arguments;
			var later = function _later() {
				timeout = null;
				if (!immediate) {
					func.apply(self, args);
				}
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(self, args);
			}
		};
	};

	Adzuki.Debounce = debounce;
}(jQuery, window.Adzuki || {}));
